import { render, staticRenderFns } from "./SecondFloor.vue?vue&type=template&id=151b4830&scoped=true&"
import script from "./SecondFloor.vue?vue&type=script&lang=js&"
export * from "./SecondFloor.vue?vue&type=script&lang=js&"
import style0 from "./SecondFloor.vue?vue&type=style&index=0&id=151b4830&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b4830",
  null
  
)

export default component.exports